import { TS_Item }              from 'Models/TravelSeller/Models/TS_Item';
import { BookingItemInterface } from 'Models/UI/BookingItemInterface';
import { TS_ItemType }          from './TS_ItemType';

export class TS_ItemIncluded extends TS_Item implements BookingItemInterface {
    type = TS_ItemType.INCL;
}